module.exports = __webpack_public_path__ + "static/media/map selected stop icon.2491811a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map selected stop icon.svg
// module id = 893
// module chunks = 0